import { toast } from 'react-toastify';
import appApi from '../../../../../../../../../api/app-api';
import { ExamSessionDetails } from '../../../../../../../../../api/types/programs/course/exams/response/exam-metadata';

export const deleteExamQuestionnaireOperation = async (
  programId: number | undefined,
  courseId: number | undefined,
  examId: number,
  sessionId: number | undefined,
  fileId: number,
  setSessionDetails: (sessions: ExamSessionDetails[]) => any,
) => {
  try {
    if (!programId || !courseId || !sessionId) {
      toast.warn('לא ניתן לאתר את מזהה התוכנית ו/או הקורס');
      return;
    }

    const res = await appApi.deleteExamSessionQuestionnaire(
      programId,
      courseId,
      examId,
      sessionId,
      fileId,
    );

    setSessionDetails(res.data.body);
  } catch (e) {
    toast.error(`משהו קרה, נסה שוב בעוד מספר רגעים...`);
    console.error(
      `deleteExamQuestionnaireOperation is failed with the programId: ${programId}, courseId: ${courseId}, examId: ${examId}, sessionId: ${sessionId} with the error: ${e}`,
    );
  }
};
